<form [formGroup]="clientFilterForm" class="ledger-filter-form">

    <div class="flexbox aff-info">
      <div class="flexbox aff-info-inner" style="width: 100%;">
        <div class="flexbox ">
          <div class="text-input-fiel">
            <!-- <input class="input-ui" searchtabindex="1" formControlName="start_date" id="from_date" type="date"
                /> -->
            <ng-container *ngIf="isLocaleDateFormat">
                  <input class="input-ui" searchtabindex="1" formControlName="start_date" id="date" type="date"
                    [ngClass]="{'error-box': !clientFilterForm.controls.start_date.valid}"
                     />
            </ng-container>
            <ng-container *ngIf="!isLocaleDateFormat && clientFilterForm.controls.start_date">
                  <app-date-time-input
                  formControlName="start_date"
                  [dateFormat]="dateFormat"
                  [fieldController]="clientFilterForm.controls.start_date"
                  class="new-date-input"
                  classes="inv-date-input" 
                  tIndex="1"
                  ></app-date-time-input>
            </ng-container>          
            <label for="from_date">Starting Date</label>
  
          </div>
          <div class="text-input-fiel">
            <!-- <input class="input-ui" searchtabindex="2" formControlName="end_date" id="to_date" type="date"
                /> -->
            <ng-container *ngIf="isLocaleDateFormat">
                  <input class="input-ui" searchtabindex="2" formControlName="end_date" id="date" type="date"
                    [ngClass]="{'error-box': !clientFilterForm.controls.end_date.valid}"
                     />
            </ng-container>
            <ng-container *ngIf="!isLocaleDateFormat && clientFilterForm.controls.end_date">
                <app-date-time-input
                  formControlName="end_date"
                  [dateFormat]="dateFormat"
                  [fieldController]="clientFilterForm.controls.end_date"
                  class="new-date-input"
                  classes="inv-date-input" 
                  tIndex="2"
                ></app-date-time-input>
            </ng-container>              
            <label for="to_date">Ending Date</label>
          </div>
        </div>
        <div class="flexBox ">
          <div class="input-fiel">
            <input class="input-ui" id="account_c" oninput="this.value = this.value.toUpperCase()" type="text"
              searchtabindex="3" formControlName="filename" placeholder="File Name" /><label
              for="account_c">File Name</label>
          </div>
        </div>
        <div class="flexbox mt-3">
          <div class="input-fiel w-100">
            <select id="gds" class="input-field w-100" oninput="this.value = this.value.toUpperCase()"
              searchtabindex="4" formControlName="gds" >
              <option  value="">All</option>
              <option  value="1A">1A</option>
              <option  value="1G">1G</option>
              <option  value="1B">1B</option>
            </select>
            <label for="gds">GDS</label>
          </div>
  
          <div class="input-fiel w-100">
            <select id="status_n" class="input-field" oninput="this.value = this.value.toUpperCase()" searchtabindex="5"
              formControlName="status">
              <option value="">All</option>
              <option value="PARSED">PARSED</option>
              <option value="ERROR">ERROR</option>
            </select>
            <label for="status_n">Status</label>
          </div>
  
  
        </div>
  
        <div class="d-flex mt-5 justify-content-center">
          <div class="input-fiel">
            <!-- <button type="button" class="btn-style mr-3" data-dismiss="modal" searchtabindex="8" #searchButton
              (keyup.enter)="clickSearchButton()" (click)="search(clientFilterForm.value)"> Search</button> -->
  
            <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" data-dismiss="modal"
              searchtabindex="6" #searchButton (keyup.enter)="clickSearchButton()"
              (click)="search(clientFilterForm.value)"> Search</button>
            <button type="button" class="btn-style bg-green" id="resetSearchForm" (click)="reset()">RESET</button>
          </div>
        </div>
  
      </div>
  
    </div>
    <!-- </div> -->
  </form>